export const TENANT_VERIFY_REQUEST = 'TENANT_VERIFY_REQUEST';
export const TENANT_VERIFY_REQUEST_SUCCESS = 'TENANT_VERIFY_REQUEST_SUCCESS';
export const TENANT_VERIFY_REQUEST_FAILURE = 'TENANT_VERIFY_REQUEST_FAILURE';
